goog.provide("shadow.js.shim.module$ol$source$Vector");
goog.provide("module$shadow_js_shim_module$ol$source$Vector");
shadow.js.shim.module$ol$source$Vector = shadow.js.nativeProvides["ol/source/Vector"] = shadow$bridge("ol/source/Vector");
module$shadow_js_shim_module$ol$source$Vector.default = shadow.js.shim.module$ol$source$Vector;
